export default {
      id: "grass-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "img/icons.50d286a4.svg#grass",
      toString: function () {
        return this.url;
      }
    }